<template>
    <div class="container px-1 mx-auto">
        <section class="mb-32 text-gray-800">
            <div class="relative overflow-hidden bg-no-repeat bg-cover" style="background-position: 50%; background-image: url('https://i.natgeofe.com/k/57f627c4-44b3-4dd6-90e1-9762bdfd03f6/deserts-palm_3x2.jpg'); height: 300px;"></div>
            <div class="container px-1 text-gray-800 md:px-12">
                <div class="block px-1 py-10 rounded-lg shadow-lg md:py-6 md:px-6" style="margin-top: -100px; background: hsla(0, 0%, 100%, 0.8); backdrop-filter: blur(30px);">
                    <div class="px-1 rounded-lg">
                        <div class="flex flex-wrap justify-between mb-2">
                            <h2 class="w-full pl-2 text-2xl font-bold lg:w-6/12 sm:w-full md:w-6/12">
                                CUCI OpenData - สะสางดอกเบี้ย
                            </h2> 
                            <div class="max-w-4xl pl-2 mt-1 text-right sm:w-full md:w-1/2 lg:w-1/2">
                                <router-link to="/openDataRibaMain">
                                    <button  class="px-2 py-1 ml-1 font-bold text-white bg-gray-600 rounded btn-sm">
                                        <i class="w-5 h-5 fa-solid fa-home"> </i>
                                    </button>
                                </router-link>
                                <router-link to="/opendataRibaBarChartYear">
                                    <button class="px-2 py-1 ml-1 font-bold text-white rounded btn-sm" :class="reportType === 'year' ? 'bg-green-500' : 'bg-blue-500'">
                                        รายปี
                                    </button>
                                </router-link>
                                <router-link to="/opendataRibaBarChartMonth">
                                    <button  class="px-2 py-1 ml-1 font-bold text-white rounded btn-sm" :class="reportType === 'month' ? 'bg-green-500' : 'bg-blue-500'">
                                        รายเดือน
                                    </button>
                                </router-link>
                            </div>
                        </div>
                        <div class="flex flex-wrap justify-between mb-2">
                            <select v-model="selectedYear" class="block px-4 py-2 pr-8 leading-tight bg-white border border-gray-400 rounded shadow appearance-none sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6 hover:border-gray-500 focus:outline-none focus:shadow-outline">
                                <option value="2568">2568</option>
                                <option value="2567">2567</option>
                                <option value="2566">2566</option>
                                <option value="2565">2565</option>
                                <option value="2564">2564</option>
                                <option value="2563">2563</option>
                                <option value="2562">2562</option>
                            </select>
                            <div class="max-w-4xl pl-2 mt-1 text-right sm:w-full md:w-1/2 lg:w-1/2 text:bold">
                                รวม : {{ totalMoney }} บาท
                            </div>
                        </div>
                        <div class="flex flex-wrap justify-center">
                            <div class="w-full sm:w-full md:w-full lg:w-full xl:w-3/4">
                                <apexchart 
                                    type="bar" 
                                    height="350" 
                                    width="100%" 
                                    :options="barChartOptions" 
                                    :series="barChartSeries">
                                </apexchart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    mounted(){
        this.barChartOptions.subtitle.text = 'ยอดสะสางดอกเบี้ยสะสมรายเดือน'
        this.selectedYear = 2568
    },
    data(){
        return{
            selectedYear: '',
            reportType: 'month',
            totalMoney: '',
            barChartOptions: {
                subtitle: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 15,
                    offsetY: 15,
                    floating: false,
                    style: {
                        fontSize:  '16px',
                        fontWeight:  'bold',
                        fontFamily:  'Helvetica, Arial, sans-serif',
                        color:  '#9699a2'
                    },
                },
                colors: ['#ffa533'],
                chart: {
                    type: 'bar',
                    // events: {
                    //     click: function(chart, w, e) {
                    //         console.log(chart, w, e)
                    //     }
                    // }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '96%',
                        endingShape: 'rounded',
                        labels:{
                            position: 'top',
                        },
                        dataLabels:{
                            orientation: 'vertical',
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: undefined,
                        formatter: function (val) {
                        //convert into k format
                        return val == 0 ? '' : (val / 1000).toFixed(2) + 'k'
                    },
                    textAnchor: 'top',
                    distributed: false,
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 'bold',
                        colors: undefined,
                        // cssClass: 'apexcharts-data-label'
                    },
                    background: {
                        enabled: true,
                        foreColor: '#fff',
                        padding: 4,
                        borderRadius: 2,
                        borderWidth: 1,
                        borderColor: '#fff',
                        opacity: 0.9,
                        dropShadow: {
                            enabled: false,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: '#000',
                            opacity: 0.45
                        }
                    },
                    dropShadow: {
                        enabled: false,
                        top: 1,
                        left: 1,
                        blur: 1,
                        color: '#000',
                        opacity: 0.45
                    }
                },
                xaxis: {
                    categories: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    labels: {
                        show: true,
                        rotate: -45,
                        rotateAlways: false,
                        hideOverlappingLabels: true,
                        showDuplicates: false,
                        trim: false,
                        minHeight: undefined,
                        maxHeight: 120,
                    }
                },
                yaxis: {
                    title: {
                        text: 'บาท'
                    },
                    //formatter label 1000 to 1,000
                    labels: {
                        formatter: function (val) {
                            return val.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        },
                        // rotate: -45,
                    }
                    
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                tooltip: {
                    theme: 'dark',
                    style: {
                        fontSize: '16px',
                        fontFamily: 'Helvetica, Arial, sans-serif'
                    },
                    x: {
                        show: true,
                        formatter: function (val) {
                            return `${val}`
                        }
                    },
                    y: {
                        formatter: function (val) {
                            return val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " บาท"
                        },
                        title: {
                            formatter: () => {
                                return `จำนวนเงิน : `;
                            }
                        }
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom',
                            //set align legend to center
                            horizontalAlign: 'center',
                        },

                    },
                }],
            },
            barChartSeries: [{
                data: [51972.19, 739217.2, 1027847.21, 307427.69, 1080165.97, 1232384.52, 207427.69]
            }],
            reportData: [
                {
                    year: 2562,
                    totalMoney: 51972.19,
                    report: [0, 0, 0, 0, 0, 168.86, 41096.2, 43946.3, 44549.61, 45658.83, 45898.01, 51972.19]
                },
                {
                    year: 2563,
                    totalMoney: 739217.20,
                    report: [263546.66, 318819.5, 336754.03, 345884.59, 354380.89, 383311.18, 659450.09, 672396.3, 683624.05, 691256.54, 696170.36, 739217.2]
                },
                {
                    year: 2564,
                    totalMoney: 875844.43,
                    report: [246310.70, 282106.98, 380980.13, 410012.56, 424983.29, 455802.93, 662925.91, 684156.10, 721649.52, 728098.46, 787331.65, 875844.43]
                },
                {
                    year: 2565,
                    totalMoney: 1031097.26,
                    report: [285558.80, 332042.81, 352654.31, 388881.10, 409673.36, 509730.00, 800842.74, 868564.08, 878460.20, 896738.89, 918810.05, 1031097.26]
                },
                {
                    year: 2566,
                    totalMoney: 1080165.97,
                    report: [288699.74, 361996.05, 416740.21, 473854.37, 517362.53, 606508.58, 852147.26, 885167.74, 908636.89, 924183.61, 953872.93, 1101145.14]
                },
                {
                    year: 2567,
                    totalMoney: 1232384.52,
                    report: [288699.74, 354835.44, 398236.49, 436371.54, 461531.15, 555201.23, 883602.94, 941327.32, 957455.98, 998703.77, 1024611.10, 1177274.15]
                },
                {
                    year: 2568,
                    totalMoney: 340443.47,
                    report: [340443.47, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }
            ]
        }
    },
    watch: {
        selectedYear(){
            let data = this.reportData.find(data => data.year == this.selectedYear)
            this.barChartSeries = [{
                data: data.report
            }]
            this.totalMoney = data.totalMoney.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    },
    methods: {
        
    }
}
</script>

<!-- <style lang="css" scoped>
    .apexcharts-data-label{
        color: black;
        /* rotate text to -90 */
        transform: rotate(-90deg) translateX(-10px) !important;
    }  
</style> -->